/* Generated from https://github.com/OPCFoundation/UA-Nodeset/blob/latest/Schema/StatusCode.csv. */

import type { Language } from "@src/reducers/your-reducer";
import { OPCUA_STATUS_CODE_TRANSLATIONS } from "./opcua-status-code-translations";

export const OPCUA_STATUS_CODES = {
  "0x00000000": { name: "Good", code: "0x00000000" },
  "0x40000000": { name: "Uncertain", code: "0x40000000" },
  "0x80000000": { name: "Bad", code: "0x80000000" },
  "0x80010000": { name: "BadUnexpectedError", code: "0x80010000" },
  "0x80020000": { name: "BadInternalError", code: "0x80020000" },
  "0x80030000": { name: "BadOutOfMemory", code: "0x80030000" },
  "0x80040000": { name: "BadResourceUnavailable", code: "0x80040000" },
  "0x80050000": { name: "BadCommunicationError", code: "0x80050000" },
  "0x80060000": { name: "BadEncodingError", code: "0x80060000" },
  "0x80070000": { name: "BadDecodingError", code: "0x80070000" },
  "0x80080000": { name: "BadEncodingLimitsExceeded", code: "0x80080000" },
  "0x80B80000": { name: "BadRequestTooLarge", code: "0x80B80000" },
  "0x80B90000": { name: "BadResponseTooLarge", code: "0x80B90000" },
  "0x80090000": { name: "BadUnknownResponse", code: "0x80090000" },
  "0x800A0000": { name: "BadTimeout", code: "0x800A0000" },
  "0x800B0000": { name: "BadServiceUnsupported", code: "0x800B0000" },
  "0x800C0000": { name: "BadShutdown", code: "0x800C0000" },
  "0x800D0000": { name: "BadServerNotConnected", code: "0x800D0000" },
  "0x800E0000": { name: "BadServerHalted", code: "0x800E0000" },
  "0x800F0000": { name: "BadNothingToDo", code: "0x800F0000" },
  "0x80100000": { name: "BadTooManyOperations", code: "0x80100000" },
  "0x80DB0000": { name: "BadTooManyMonitoredItems", code: "0x80DB0000" },
  "0x80110000": { name: "BadDataTypeIdUnknown", code: "0x80110000" },
  "0x80120000": { name: "BadCertificateInvalid", code: "0x80120000" },
  "0x80130000": { name: "BadSecurityChecksFailed", code: "0x80130000" },
  "0x81140000": { name: "BadCertificatePolicyCheckFailed", code: "0x81140000" },
  "0x80140000": { name: "BadCertificateTimeInvalid", code: "0x80140000" },
  "0x80150000": { name: "BadCertificateIssuerTimeInvalid", code: "0x80150000" },
  "0x80160000": { name: "BadCertificateHostNameInvalid", code: "0x80160000" },
  "0x80170000": { name: "BadCertificateUriInvalid", code: "0x80170000" },
  "0x80180000": { name: "BadCertificateUseNotAllowed", code: "0x80180000" },
  "0x80190000": {
    name: "BadCertificateIssuerUseNotAllowed",
    code: "0x80190000",
  },
  "0x801A0000": { name: "BadCertificateUntrusted", code: "0x801A0000" },
  "0x801B0000": { name: "BadCertificateRevocationUnknown", code: "0x801B0000" },
  "0x801C0000": {
    name: "BadCertificateIssuerRevocationUnknown",
    code: "0x801C0000",
  },
  "0x801D0000": { name: "BadCertificateRevoked", code: "0x801D0000" },
  "0x801E0000": { name: "BadCertificateIssuerRevoked", code: "0x801E0000" },
  "0x810D0000": { name: "BadCertificateChainIncomplete", code: "0x810D0000" },
  "0x801F0000": { name: "BadUserAccessDenied", code: "0x801F0000" },
  "0x80200000": { name: "BadIdentityTokenInvalid", code: "0x80200000" },
  "0x80210000": { name: "BadIdentityTokenRejected", code: "0x80210000" },
  "0x80220000": { name: "BadSecureChannelIdInvalid", code: "0x80220000" },
  "0x80230000": { name: "BadInvalidTimestamp", code: "0x80230000" },
  "0x80240000": { name: "BadNonceInvalid", code: "0x80240000" },
  "0x80250000": { name: "BadSessionIdInvalid", code: "0x80250000" },
  "0x80260000": { name: "BadSessionClosed", code: "0x80260000" },
  "0x80270000": { name: "BadSessionNotActivated", code: "0x80270000" },
  "0x80280000": { name: "BadSubscriptionIdInvalid", code: "0x80280000" },
  "0x802A0000": { name: "BadRequestHeaderInvalid", code: "0x802A0000" },
  "0x802B0000": { name: "BadTimestampsToReturnInvalid", code: "0x802B0000" },
  "0x802C0000": { name: "BadRequestCancelledByClient", code: "0x802C0000" },
  "0x80E50000": { name: "BadTooManyArguments", code: "0x80E50000" },
  "0x810E0000": { name: "BadLicenseExpired", code: "0x810E0000" },
  "0x810F0000": { name: "BadLicenseLimitsExceeded", code: "0x810F0000" },
  "0x81100000": { name: "BadLicenseNotAvailable", code: "0x81100000" },
  "0x80EE0000": { name: "BadServerTooBusy", code: "0x80EE0000" },
  "0x00EF0000": { name: "GoodPasswordChangeRequired", code: "0x00EF0000" },
  "0x002D0000": { name: "GoodSubscriptionTransferred", code: "0x002D0000" },
  "0x002E0000": { name: "GoodCompletesAsynchronously", code: "0x002E0000" },
  "0x002F0000": { name: "GoodOverload", code: "0x002F0000" },
  "0x00300000": { name: "GoodClamped", code: "0x00300000" },
  "0x80310000": { name: "BadNoCommunication", code: "0x80310000" },
  "0x80320000": { name: "BadWaitingForInitialData", code: "0x80320000" },
  "0x80330000": { name: "BadNodeIdInvalid", code: "0x80330000" },
  "0x80340000": { name: "BadNodeIdUnknown", code: "0x80340000" },
  "0x80350000": { name: "BadAttributeIdInvalid", code: "0x80350000" },
  "0x80360000": { name: "BadIndexRangeInvalid", code: "0x80360000" },
  "0x80370000": { name: "BadIndexRangeNoData", code: "0x80370000" },
  "0x80EA0000": { name: "BadIndexRangeDataMismatch", code: "0x80EA0000" },
  "0x80380000": { name: "BadDataEncodingInvalid", code: "0x80380000" },
  "0x80390000": { name: "BadDataEncodingUnsupported", code: "0x80390000" },
  "0x803A0000": { name: "BadNotReadable", code: "0x803A0000" },
  "0x803B0000": { name: "BadNotWritable", code: "0x803B0000" },
  "0x803C0000": { name: "BadOutOfRange", code: "0x803C0000" },
  "0x40F20000": { name: "UncertainOverRange", code: "0x40F20000" },
  "0x40F30000": { name: "UncertainUnderRange", code: "0x40F30000" },
  "0x803D0000": { name: "BadNotSupported", code: "0x803D0000" },
  "0x803E0000": { name: "BadNotFound", code: "0x803E0000" },
  "0x803F0000": { name: "BadObjectDeleted", code: "0x803F0000" },
  "0x80400000": { name: "BadNotImplemented", code: "0x80400000" },
  "0x80410000": { name: "BadMonitoringModeInvalid", code: "0x80410000" },
  "0x80420000": { name: "BadMonitoredItemIdInvalid", code: "0x80420000" },
  "0x80430000": { name: "BadMonitoredItemFilterInvalid", code: "0x80430000" },
  "0x80440000": {
    name: "BadMonitoredItemFilterUnsupported",
    code: "0x80440000",
  },
  "0x80450000": { name: "BadFilterNotAllowed", code: "0x80450000" },
  "0x80460000": { name: "BadStructureMissing", code: "0x80460000" },
  "0x80470000": { name: "BadEventFilterInvalid", code: "0x80470000" },
  "0x80480000": { name: "BadContentFilterInvalid", code: "0x80480000" },
  "0x80C10000": { name: "BadFilterOperatorInvalid", code: "0x80C10000" },
  "0x80C20000": { name: "BadFilterOperatorUnsupported", code: "0x80C20000" },
  "0x80C30000": { name: "BadFilterOperandCountMismatch", code: "0x80C30000" },
  "0x80490000": { name: "BadFilterOperandInvalid", code: "0x80490000" },
  "0x80C40000": { name: "BadFilterElementInvalid", code: "0x80C40000" },
  "0x80C50000": { name: "BadFilterLiteralInvalid", code: "0x80C50000" },
  "0x804A0000": { name: "BadContinuationPointInvalid", code: "0x804A0000" },
  "0x804B0000": { name: "BadNoContinuationPoints", code: "0x804B0000" },
  "0x804C0000": { name: "BadReferenceTypeIdInvalid", code: "0x804C0000" },
  "0x804D0000": { name: "BadBrowseDirectionInvalid", code: "0x804D0000" },
  "0x804E0000": { name: "BadNodeNotInView", code: "0x804E0000" },
  "0x81120000": { name: "BadNumericOverflow", code: "0x81120000" },
  "0x80ED0000": { name: "BadLocaleNotSupported", code: "0x80ED0000" },
  "0x80F00000": { name: "BadNoValue", code: "0x80F00000" },
  "0x804F0000": { name: "BadServerUriInvalid", code: "0x804F0000" },
  "0x80500000": { name: "BadServerNameMissing", code: "0x80500000" },
  "0x80510000": { name: "BadDiscoveryUrlMissing", code: "0x80510000" },
  "0x80520000": { name: "BadSemaphoreFileMissing", code: "0x80520000" },
  "0x80530000": { name: "BadRequestTypeInvalid", code: "0x80530000" },
  "0x80540000": { name: "BadSecurityModeRejected", code: "0x80540000" },
  "0x80550000": { name: "BadSecurityPolicyRejected", code: "0x80550000" },
  "0x80560000": { name: "BadTooManySessions", code: "0x80560000" },
  "0x80570000": { name: "BadUserSignatureInvalid", code: "0x80570000" },
  "0x80580000": { name: "BadApplicationSignatureInvalid", code: "0x80580000" },
  "0x80590000": { name: "BadNoValidCertificates", code: "0x80590000" },
  "0x80C60000": { name: "BadIdentityChangeNotSupported", code: "0x80C60000" },
  "0x805A0000": { name: "BadRequestCancelledByRequest", code: "0x805A0000" },
  "0x805B0000": { name: "BadParentNodeIdInvalid", code: "0x805B0000" },
  "0x805C0000": { name: "BadReferenceNotAllowed", code: "0x805C0000" },
  "0x805D0000": { name: "BadNodeIdRejected", code: "0x805D0000" },
  "0x805E0000": { name: "BadNodeIdExists", code: "0x805E0000" },
  "0x805F0000": { name: "BadNodeClassInvalid", code: "0x805F0000" },
  "0x80600000": { name: "BadBrowseNameInvalid", code: "0x80600000" },
  "0x80610000": { name: "BadBrowseNameDuplicated", code: "0x80610000" },
  "0x80620000": { name: "BadNodeAttributesInvalid", code: "0x80620000" },
  "0x80630000": { name: "BadTypeDefinitionInvalid", code: "0x80630000" },
  "0x80640000": { name: "BadSourceNodeIdInvalid", code: "0x80640000" },
  "0x80650000": { name: "BadTargetNodeIdInvalid", code: "0x80650000" },
  "0x80660000": { name: "BadDuplicateReferenceNotAllowed", code: "0x80660000" },
  "0x80670000": { name: "BadInvalidSelfReference", code: "0x80670000" },
  "0x80680000": { name: "BadReferenceLocalOnly", code: "0x80680000" },
  "0x80690000": { name: "BadNoDeleteRights", code: "0x80690000" },
  "0x40BC0000": { name: "UncertainReferenceNotDeleted", code: "0x40BC0000" },
  "0x806A0000": { name: "BadServerIndexInvalid", code: "0x806A0000" },
  "0x806B0000": { name: "BadViewIdUnknown", code: "0x806B0000" },
  "0x80C90000": { name: "BadViewTimestampInvalid", code: "0x80C90000" },
  "0x80CA0000": { name: "BadViewParameterMismatch", code: "0x80CA0000" },
  "0x80CB0000": { name: "BadViewVersionInvalid", code: "0x80CB0000" },
  "0x40C00000": { name: "UncertainNotAllNodesAvailable", code: "0x40C00000" },
  "0x00BA0000": { name: "GoodResultsMayBeIncomplete", code: "0x00BA0000" },
  "0x80C80000": { name: "BadNotTypeDefinition", code: "0x80C80000" },
  "0x406C0000": { name: "UncertainReferenceOutOfServer", code: "0x406C0000" },
  "0x806D0000": { name: "BadTooManyMatches", code: "0x806D0000" },
  "0x806E0000": { name: "BadQueryTooComplex", code: "0x806E0000" },
  "0x806F0000": { name: "BadNoMatch", code: "0x806F0000" },
  "0x80700000": { name: "BadMaxAgeInvalid", code: "0x80700000" },
  "0x80E60000": { name: "BadSecurityModeInsufficient", code: "0x80E60000" },
  "0x80710000": { name: "BadHistoryOperationInvalid", code: "0x80710000" },
  "0x80720000": { name: "BadHistoryOperationUnsupported", code: "0x80720000" },
  "0x80BD0000": { name: "BadInvalidTimestampArgument", code: "0x80BD0000" },
  "0x80730000": { name: "BadWriteNotSupported", code: "0x80730000" },
  "0x80740000": { name: "BadTypeMismatch", code: "0x80740000" },
  "0x80750000": { name: "BadMethodInvalid", code: "0x80750000" },
  "0x80760000": { name: "BadArgumentsMissing", code: "0x80760000" },
  "0x81110000": { name: "BadNotExecutable", code: "0x81110000" },
  "0x80770000": { name: "BadTooManySubscriptions", code: "0x80770000" },
  "0x80780000": { name: "BadTooManyPublishRequests", code: "0x80780000" },
  "0x80790000": { name: "BadNoSubscription", code: "0x80790000" },
  "0x807A0000": { name: "BadSequenceNumberUnknown", code: "0x807A0000" },
  "0x00DF0000": {
    name: "GoodRetransmissionQueueNotSupported",
    code: "0x00DF0000",
  },
  "0x807B0000": { name: "BadMessageNotAvailable", code: "0x807B0000" },
  "0x807C0000": { name: "BadInsufficientClientProfile", code: "0x807C0000" },
  "0x80BF0000": { name: "BadStateNotActive", code: "0x80BF0000" },
  "0x81150000": { name: "BadAlreadyExists", code: "0x81150000" },
  "0x807D0000": { name: "BadTcpServerTooBusy", code: "0x807D0000" },
  "0x807E0000": { name: "BadTcpMessageTypeInvalid", code: "0x807E0000" },
  "0x807F0000": { name: "BadTcpSecureChannelUnknown", code: "0x807F0000" },
  "0x80800000": { name: "BadTcpMessageTooLarge", code: "0x80800000" },
  "0x80810000": { name: "BadTcpNotEnoughResources", code: "0x80810000" },
  "0x80820000": { name: "BadTcpInternalError", code: "0x80820000" },
  "0x80830000": { name: "BadTcpEndpointUrlInvalid", code: "0x80830000" },
  "0x80840000": { name: "BadRequestInterrupted", code: "0x80840000" },
  "0x80850000": { name: "BadRequestTimeout", code: "0x80850000" },
  "0x80860000": { name: "BadSecureChannelClosed", code: "0x80860000" },
  "0x80870000": { name: "BadSecureChannelTokenUnknown", code: "0x80870000" },
  "0x80880000": { name: "BadSequenceNumberInvalid", code: "0x80880000" },
  "0x80BE0000": { name: "BadProtocolVersionUnsupported", code: "0x80BE0000" },
  "0x80890000": { name: "BadConfigurationError", code: "0x80890000" },
  "0x808A0000": { name: "BadNotConnected", code: "0x808A0000" },
  "0x808B0000": { name: "BadDeviceFailure", code: "0x808B0000" },
  "0x808C0000": { name: "BadSensorFailure", code: "0x808C0000" },
  "0x808D0000": { name: "BadOutOfService", code: "0x808D0000" },
  "0x808E0000": { name: "BadDeadbandFilterInvalid", code: "0x808E0000" },
  "0x408F0000": {
    name: "UncertainNoCommunicationLastUsableValue",
    code: "0x408F0000",
  },
  "0x40900000": { name: "UncertainLastUsableValue", code: "0x40900000" },
  "0x40910000": { name: "UncertainSubstituteValue", code: "0x40910000" },
  "0x40920000": { name: "UncertainInitialValue", code: "0x40920000" },
  "0x40930000": { name: "UncertainSensorNotAccurate", code: "0x40930000" },
  "0x40940000": {
    name: "UncertainEngineeringUnitsExceeded",
    code: "0x40940000",
  },
  "0x40950000": { name: "UncertainSubNormal", code: "0x40950000" },
  "0x00960000": { name: "GoodLocalOverride", code: "0x00960000" },
  "0x00EB0000": { name: "GoodSubNormal", code: "0x00EB0000" },
  "0x80970000": { name: "BadRefreshInProgress", code: "0x80970000" },
  "0x80980000": { name: "BadConditionAlreadyDisabled", code: "0x80980000" },
  "0x80CC0000": { name: "BadConditionAlreadyEnabled", code: "0x80CC0000" },
  "0x80990000": { name: "BadConditionDisabled", code: "0x80990000" },
  "0x809A0000": { name: "BadEventIdUnknown", code: "0x809A0000" },
  "0x80BB0000": { name: "BadEventNotAcknowledgeable", code: "0x80BB0000" },
  "0x80CD0000": { name: "BadDialogNotActive", code: "0x80CD0000" },
  "0x80CE0000": { name: "BadDialogResponseInvalid", code: "0x80CE0000" },
  "0x80CF0000": { name: "BadConditionBranchAlreadyAcked", code: "0x80CF0000" },
  "0x80D00000": {
    name: "BadConditionBranchAlreadyConfirmed",
    code: "0x80D00000",
  },
  "0x80D10000": { name: "BadConditionAlreadyShelved", code: "0x80D10000" },
  "0x80D20000": { name: "BadConditionNotShelved", code: "0x80D20000" },
  "0x80D30000": { name: "BadShelvingTimeOutOfRange", code: "0x80D30000" },
  "0x809B0000": { name: "BadNoData", code: "0x809B0000" },
  "0x80D70000": { name: "BadBoundNotFound", code: "0x80D70000" },
  "0x80D80000": { name: "BadBoundNotSupported", code: "0x80D80000" },
  "0x809D0000": { name: "BadDataLost", code: "0x809D0000" },
  "0x809E0000": { name: "BadDataUnavailable", code: "0x809E0000" },
  "0x809F0000": { name: "BadEntryExists", code: "0x809F0000" },
  "0x80A00000": { name: "BadNoEntryExists", code: "0x80A00000" },
  "0x80A10000": { name: "BadTimestampNotSupported", code: "0x80A10000" },
  "0x00A20000": { name: "GoodEntryInserted", code: "0x00A20000" },
  "0x00A30000": { name: "GoodEntryReplaced", code: "0x00A30000" },
  "0x40A40000": { name: "UncertainDataSubNormal", code: "0x40A40000" },
  "0x00A50000": { name: "GoodNoData", code: "0x00A50000" },
  "0x00A60000": { name: "GoodMoreData", code: "0x00A60000" },
  "0x80D40000": { name: "BadAggregateListMismatch", code: "0x80D40000" },
  "0x80D50000": { name: "BadAggregateNotSupported", code: "0x80D50000" },
  "0x80D60000": { name: "BadAggregateInvalidInputs", code: "0x80D60000" },
  "0x80DA0000": {
    name: "BadAggregateConfigurationRejected",
    code: "0x80DA0000",
  },
  "0x00D90000": { name: "GoodDataIgnored", code: "0x00D90000" },
  "0x80E40000": { name: "BadRequestNotAllowed", code: "0x80E40000" },
  "0x81130000": { name: "BadRequestNotComplete", code: "0x81130000" },
  "0x80E80000": { name: "BadTransactionPending", code: "0x80E80000" },
  "0x80F10000": { name: "BadTransactionFailed", code: "0x80F10000" },
  "0x811F0000": { name: "BadTicketRequired", code: "0x811F0000" },
  "0x81200000": { name: "BadTicketInvalid", code: "0x81200000" },
  "0x80E90000": { name: "BadLocked", code: "0x80E90000" },
  "0x80EC0000": { name: "BadRequiresLock", code: "0x80EC0000" },
  "0x00DC0000": { name: "GoodEdited", code: "0x00DC0000" },
  "0x00DD0000": { name: "GoodPostActionFailed", code: "0x00DD0000" },
  "0x40DE0000": { name: "UncertainDominantValueChanged", code: "0x40DE0000" },
  "0x00E00000": { name: "GoodDependentValueChanged", code: "0x00E00000" },
  "0x80E10000": { name: "BadDominantValueChanged", code: "0x80E10000" },
  "0x40E20000": { name: "UncertainDependentValueChanged", code: "0x40E20000" },
  "0x80E30000": { name: "BadDependentValueChanged", code: "0x80E30000" },
  "0x01160000": {
    name: "GoodEdited_DependentValueChanged",
    code: "0x01160000",
  },
  "0x01170000": { name: "GoodEdited_DominantValueChanged", code: "0x01170000" },
  "0x01180000": {
    name: "GoodEdited_DominantValueChanged_DependentValueChanged",
    code: "0x01180000",
  },
  "0x81190000": { name: "BadEdited_OutOfRange", code: "0x81190000" },
  "0x811A0000": { name: "BadInitialValue_OutOfRange", code: "0x811A0000" },
  "0x811B0000": {
    name: "BadOutOfRange_DominantValueChanged",
    code: "0x811B0000",
  },
  "0x811C0000": {
    name: "BadEdited_OutOfRange_DominantValueChanged",
    code: "0x811C0000",
  },
  "0x811D0000": {
    name: "BadOutOfRange_DominantValueChanged_DependentValueChanged",
    code: "0x811D0000",
  },
  "0x811E0000": {
    name: "BadEdited_OutOfRange_DominantValueChanged_DependentValueChanged",
    code: "0x811E0000",
  },
  "0x00A70000": { name: "GoodCommunicationEvent", code: "0x00A70000" },
  "0x00A80000": { name: "GoodShutdownEvent", code: "0x00A80000" },
  "0x00A90000": { name: "GoodCallAgain", code: "0x00A90000" },
  "0x00AA0000": { name: "GoodNonCriticalTimeout", code: "0x00AA0000" },
  "0x80AB0000": { name: "BadInvalidArgument", code: "0x80AB0000" },
  "0x80AC0000": { name: "BadConnectionRejected", code: "0x80AC0000" },
  "0x80AD0000": { name: "BadDisconnect", code: "0x80AD0000" },
  "0x80AE0000": { name: "BadConnectionClosed", code: "0x80AE0000" },
  "0x80AF0000": { name: "BadInvalidState", code: "0x80AF0000" },
  "0x80B00000": { name: "BadEndOfStream", code: "0x80B00000" },
  "0x80B10000": { name: "BadNoDataAvailable", code: "0x80B10000" },
  "0x80B20000": { name: "BadWaitingForResponse", code: "0x80B20000" },
  "0x80B30000": { name: "BadOperationAbandoned", code: "0x80B30000" },
  "0x80B40000": { name: "BadExpectedStreamToBlock", code: "0x80B40000" },
  "0x80B50000": { name: "BadWouldBlock", code: "0x80B50000" },
  "0x80B60000": { name: "BadSyntaxError", code: "0x80B60000" },
  "0x80B70000": { name: "BadMaxConnectionsReached", code: "0x80B70000" },
  "0x42080000": { name: "UncertainTransducerInManual", code: "0x42080000" },
  "0x42090000": { name: "UncertainSimulatedValue", code: "0x42090000" },
  "0x420A0000": { name: "UncertainSensorCalibration", code: "0x420A0000" },
  "0x420F0000": { name: "UncertainConfigurationError", code: "0x420F0000" },
  "0x04010000": {
    name: "GoodCascadeInitializationAcknowledged",
    code: "0x04010000",
  },
  "0x04020000": {
    name: "GoodCascadeInitializationRequest",
    code: "0x04020000",
  },
  "0x04030000": { name: "GoodCascadeNotInvited", code: "0x04030000" },
  "0x04040000": { name: "GoodCascadeNotSelected", code: "0x04040000" },
  "0x04070000": { name: "GoodFaultStateActive", code: "0x04070000" },
  "0x04080000": { name: "GoodInitiateFaultState", code: "0x04080000" },
  "0x04090000": { name: "GoodCascade", code: "0x04090000" },
  "0x80E70000": { name: "BadDataSetIdInvalid", code: "0x80E70000" },
} satisfies Record<string, { name: string; code: string }>;

export type OpcUaStatusCode = keyof typeof OPCUA_STATUS_CODES;
type OpcUaStatusCodeBaseDetails = (typeof OPCUA_STATUS_CODES)[OpcUaStatusCode];

export type OpcUaStatusCodeDetails = Omit<
  OpcUaStatusCodeBaseDetails,
  "code"
> & {
  code: OpcUaStatusCode;
  description: string;
};

const isOpcUaStatusCode = (value: string): value is OpcUaStatusCode =>
  Object.prototype.hasOwnProperty.call(OPCUA_STATUS_CODES, value);

const normalizeOpcUaStatusCode = (
  value: number | string,
): string | undefined => {
  let numericValue: number;

  if (
    typeof value === "number" &&
    Number.isInteger(value) &&
    value >= 0 &&
    value <= 0xffffffff
  ) {
    numericValue = value;
  } else if (typeof value === "string" && /^0x[0-9a-f]{1,8}$/i.test(value)) {
    numericValue = Number.parseInt(value.slice(2), 16);
  } else {
    return undefined;
  }

  // The lower 16 bits contain OPC UA diagnostic/info bits. The status-code
  // table is keyed by the base code, so remove those bits before lookup.
  const baseCode = ((numericValue >>> 0) & 0xffff0000) >>> 0;
  return `0x${baseCode.toString(16).padStart(8, "0").toUpperCase()}`;
};

export const getOpcUaStatusCodeDetails = (
  value: number | string,
): OpcUaStatusCodeDetails | undefined => {
  const normalizedCode = normalizeOpcUaStatusCode(value);
  if (!normalizedCode || !isOpcUaStatusCode(normalizedCode)) {
    return undefined;
  }

  const statusCode = OPCUA_STATUS_CODES[normalizedCode];

  return {
    ...statusCode,
    code: normalizedCode,
    description: OPCUA_STATUS_CODE_TRANSLATIONS.en[normalizedCode],
  };
};

export const getOpcUaErrorDescriptions = (
  additionalErrorCodes?: Array<{
    type?: string;
    error_code?: number | string;
  }>,
  language: Language = "en",
): string[] =>
  (Array.isArray(additionalErrorCodes) ? additionalErrorCodes : []).flatMap(
    (entry) => {
      if (
        !entry ||
        typeof entry !== "object" ||
        typeof entry.type !== "string" ||
        entry.type.trim().toUpperCase() !== "OPCUA" ||
        entry.error_code === undefined
      ) {
        return [];
      }

      const statusCodeDetails = getOpcUaStatusCodeDetails(entry.error_code);
      if (!statusCodeDetails) {
        return [];
      }

      const localizedDescription =
        language && language !== "en"
          ? OPCUA_STATUS_CODE_TRANSLATIONS[language]?.[statusCodeDetails.code]
          : undefined;
      const description = localizedDescription || statusCodeDetails.description;
      return description ? [description] : [];
    },
  );
